import React from "react";
import HomePage from "./Components/HomePage"
import CookieBar from "./Components/CookieBar";

const Root = () => {
    return <>
        <HomePage />
        <CookieBar />
    </>
    
}
export default Root